import { Injectable } from '@angular/core';
import { HttpLogado } from '../HttpLogado';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import convertHttpErrorToLocal from 'src/utils/convertHttpErrorToLocal';
import { User } from 'src/classes/user';

@Injectable()
export class UserService {

  constructor(
    private http: HttpLogado,
    private httpAnon: HttpClient
  ) { }

  async register(
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    repeatPassword: string,
    company: string,
    phone: string,
    country: string,
    token: string
  ) {
    try {
      const data = {
        email,
        password,
        repeatPassword,
        token,
        params: {firstName, lastName, company, phone, country}
      };
      return await (this.httpAnon.post(`${environment.baseUrl}/user`, data).toPromise() as Promise<any>);
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  async changePassword(password, repeatPassword): Promise<any> {
    try {
      return await (this.http.post(`${environment.baseUrl}/user/password/change`, {password, repeatPassword}).toPromise() as Promise<any>);
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  async get(): Promise<User> {
    try {
      const userData = await this.http.get(`${environment.baseUrl}/user`).toPromise();
      const user: any = Object.assign(new User(), userData);
      user.setParams(user.params);
      delete user.params;
      return user as User;
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  async patchParams(paramList: {idParam?: number, value: string, key: string}[]) {
    try {
      await this.http.patch(`${environment.baseUrl}/user/params`, paramList).toPromise();
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  async updatePaymentData(
    idPlan: string,
    paymentType: "Subscription" | "Billing",
    company: string,
    taxID: string,
    stateRegister: string,
    billingMail: string,
    zipCode: string,
    federalUnit: string,
    city: string,
    neighborhood: string,
    address: string,
    addressNumber: string,
    addressComplement: string,
    subscriptionId: string,
    daysBeforeDue: number,
    personType: string
  ) {
    const paramList = {
      idPlan,
      paymentType,
      company,
      taxID,
      stateRegister,
      billingMail,
      zipCode,
      federalUnit,
      city,
      neighborhood,
      address,
      addressNumber,
      addressComplement,
      subscriptionId,
      daysBeforeDue,
      personType
    }
    try {
      await this.http.post(`${environment.baseUrl}/user/payment`, paramList).toPromise();
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  async testSmtpConfig(data: {
    smtpHost: string,
    smtpPort: string,
    smtpUser: string,
    smtpPassword: string,
    smtpEmailFrom: string,
    smtpIsSafe: "1" | "0",
    mailMode: "smtp"
  }) {
    let result;
    try {
      result = await this.http.post(`${environment.baseUrl}/user/test/smtp`, data).toPromise();
    } catch (err) {
      console.log(err);
      convertHttpErrorToLocal(err);
    }
    console.log(result);
    return result;
  }

  async active(token: string) {
    let result;
    try {
      result = await this.http.post(`${environment.baseUrl}/user/active`, {token}).toPromise();
    } catch (err) {
      console.log(err);
      convertHttpErrorToLocal(err);
    }
    console.log(result);
    return result;
  }

  async resend(email: string) {
    let result;
    try {
      result = await this.http.post(`${environment.baseUrl}/user/active/resend`, {email,token:email}).toPromise();
    } catch (err) {
      console.log(err);
      convertHttpErrorToLocal(err);
    }
    console.log(result);
    return result;
  }
}
